
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import initpage from './pages/initpage/initpage'
import productspage from './pages/productspage/productspage'
import productinfo from './pages/productinfo/productinfo'
import shopcartinfo from './pages/shopcartinfo/shopcartinfo'
import checkoutinfo from './pages/checkoutinfo/checkoutinfo'
import certificacionesd1n5n from './pages/certificacionesd1n5n/certificacionesd1n5n'
import contactox2m2p from './pages/contactox2m2p/contactox2m2p'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={initpage} />
			<Route exact path="/productos" component={productspage} />
			<Route exact path="/producto/:_id" component={productinfo} />
			<Route exact path="/carritocompras" component={shopcartinfo} />
			<Route exact path="/orden/:_id" component={checkoutinfo} />
			<Route exact path="/certificaciones" component={certificacionesd1n5n} />
			<Route exact path="/contacto" component={contactox2m2p} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

